module.exports = __webpack_public_path__ + "img/footballBanner_600.b20b812b.png";